import React, {
    useState,
    useRef,
    useContext, useEffect,
} from "react";

import { crudeDatabase } from "../data/crudeDatabase";
import { generateBlend } from "../engine/blendEngine";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

import "../components/LoadingReceipt.css";

import { ProcessContext } from "../context/ProcessContext";






function MainFractionationLaboratory({ onClose }) {

    const [currentPage, setCurrentPage] = useState(0);



    const report =
        JSON.parse(
            localStorage.getItem(
                "MAIN_FRACTIONATION_REPORT"
            )
        ) || {};

    const feed =
        report.feed || {};

    const operation =
        report.operation || {};

    const flashZone =
        report.flashZone || {};

    const tower =
        report.tower || {};

    const overhead =
        report.overhead || {};

    const sideDraws =
        report.sideDraws || {};

    const bottoms =
        report.bottoms || {};

    const performance =
        report.performance || {};





    const top = tower.top || {};

    const upperSection = tower.upperSection || {};

    const middle = tower.middle || {};

    const flash = tower.flashZone || {};

    const bottom = tower.bottom || {};

    const kerosene = sideDraws.kerosene || {};

    const diesel = sideDraws.diesel || {};




    /* =========================================================
       LIVE DATA FROM MAIN FRACTIONATION TOWERS
    ========================================================= */

    const {
        transmitters
    } = usePlantStore();

    /* =============================
       BOTTOM TOWER
    ============================= */

    const FIC_2301 =
        Number(localStorage.getItem("FIC_2301")) || 0;

    const TT_2301 =
        feed.temperature || 0;

    const PT_2301 =
        feed.pressure || 0;

    const TT_2303 =
        bottom.temperature || 0;

    const TT_2304 =
        Number(localStorage.getItem("TT_2304")) || 0;

    const TT_2305 =
        Number(localStorage.getItem("TT_2305")) || 0;

    const TT_2306 =
        Number(localStorage.getItem("TT_2306")) || 0;

    const TT_2307 =
        bottom.productTemperature || 0;

    const TT_2309 =
        Number(localStorage.getItem("TT_2309")) || 0;

    const PT_2303 =
        flash.pressure || 0;

    const PT_2304 =
        Number(localStorage.getItem("PT_2304")) || 0;

    const PT_2305 =
        Number(localStorage.getItem("PT_2305")) || 0;

    const PT_2306 =
        Number(localStorage.getItem("PT_2306")) || 0;

    const FIC_2305 =
        Number(localStorage.getItem("FIC_2305")) || 0;

    const FIC_2306 =
        Number(localStorage.getItem("FIC_2306")) || 0;

    const FIC_2307 =
        Number(localStorage.getItem("FIC_2307")) || 0;

    const FlashSeverity =
        Number(localStorage.getItem("FlashSeverity")) || 0;

    const FlashZoneVaporFlow =
        Number(localStorage.getItem("FlashZoneVaporFlow")) || 0;

    const FlashZoneLiquidFlow =
        Number(localStorage.getItem("FlashZoneLiquidFlow")) || 0;

    const FlashZoneVaporComposition =
        JSON.parse(
            localStorage.getItem("FlashZoneVaporComposition")
        ) || {};

    const FlashZoneLiquidComposition =
        JSON.parse(
            localStorage.getItem("FlashZoneLiquidComposition")
        ) || {};

    const OverheadComposition =
        JSON.parse(
            localStorage.getItem("OverheadComposition")
        ) || {};

    const KeroseneProduct =
        JSON.parse(
            localStorage.getItem("KeroseneProduct")
        ) || {};

    const KeroseneProductComposition =
        JSON.parse(
            localStorage.getItem("KeroseneProductComposition")
        ) || {};

    const DieselProductComposition =
        JSON.parse(
            localStorage.getItem("DieselProductComposition")
        ) || {};

    /* =============================
       TOP TOWER
    ============================= */

    const TT_2201 =
        Number(localStorage.getItem("TT_2201")) || 0;

    const TT_2202 =
        Number(localStorage.getItem("TT_2202")) || 0;

    const TT_2203 =
        Number(localStorage.getItem("TT_2203")) || 0;

    const TT_2204 =
        Number(localStorage.getItem("TT_2204")) || 0;

    const TT_2205 =
        Number(localStorage.getItem("TT_2205")) || 0;

    const TT_2206 =
        Number(localStorage.getItem("TT_2206")) || 0;

    const PT_2201 =
        Number(localStorage.getItem("PT_2201")) || 0;

    const PT_2203 =
        Number(localStorage.getItem("PT_2203")) || 0;

    const PT_2206 =
        Number(localStorage.getItem("PT_2206")) || 0;

    const FIC_2203 =
        Number(localStorage.getItem("FIC_2203")) || 0;

    const FIC_2204 =
        Number(localStorage.getItem("FIC_2204")) || 0;

    const FIC_2205 =
        Number(localStorage.getItem("FIC_2205")) || 0;

    const FIC_2206 =
        Number(localStorage.getItem("FIC_2206")) || 0;

    /* =============================
       LIVE PUMP-AROUND
    ============================= */

    const TT_22011 =
        transmitters.TT_22011 || 0;

    const PT_22011 =
        transmitters.PT_22011 || 0;

    const FIC_22011 =
        transmitters.FIC_22011 || 0;

    const TT_2308 =
        transmitters.TT_2308 || 0;

    const PT_2308 =
        transmitters.PT_2308 || 0;

    const FIC_2308 =
        transmitters.FIC_2308 || 0;






    const [position, setPosition] = useState({
        x: 120,
        y: 40
    });

    const [dragging, setDragging] = useState(false);

    const offsetRef = useRef({
        x: 0,
        y: 0
    });

    const startDrag = (e) => {

        setDragging(true);

        offsetRef.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };


    const handleMouseMove = (e) => {

        if (!dragging) return;

        setPosition({

            x: e.clientX - offsetRef.current.x,

            y: e.clientY - offsetRef.current.y

        });

    };


    const stopDrag = () => {

        setDragging(false);

    };



    useEffect(() => {

        window.addEventListener(
            "mousemove",
            handleMouseMove
        );

        window.addEventListener(
            "mouseup",
            stopDrag
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                handleMouseMove
            );

            window.removeEventListener(
                "mouseup",
                stopDrag
            );

        };

    }, [dragging]);





    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y,
                width: "680px",
                height: "88vh",
                display: "flex",
                flexDirection: "column"
            }}
        >


            {/* HEADER */}

            <div
                className="receipt-header"
                onMouseDown={startDrag}
                style={{
                    cursor: "move"
                }}
            >

                <div>
                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION
                </div>


                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕
                </button>


            </div>





            <div className="receipt-scroll">

                {/* =========================================================
    PAGE 0
    COVER PAGE
========================================================= */}

                {currentPage === 0 && (

                    <div className="receipt-page">

                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: 30
                            }}
                        >

                            <div
                                style={{
                                    fontSize: 18,
                                    fontWeight: "bold",
                                    color: "#003366",
                                    letterSpacing: 1
                                }}
                            >
                                NK TECH NIGERIA LIMITED
                            </div>

                            <div
                                style={{
                                    fontSize: 14,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                NK REFINERY DIGITAL TWIN SYSTEM
                            </div>

                            <div
                                style={{
                                    fontSize: 13,
                                    marginTop: 4,
                                    color: "#666"
                                }}
                            >
                                PROCESS SIMULATION • DIGITAL LABORATORY • OPERATIONS MONITORING
                            </div>

                        </div>

                        <hr />

                        <div
                            style={{
                                textAlign: "center",
                                margin: "30px 0"
                            }}
                        >

                            <h1
                                style={{
                                    margin: 0,
                                    fontSize: 34,
                                    color: "#0B4F9C",
                                    letterSpacing: 2
                                }}
                            >
                                MAIN FRACTIONATION TOWER
                            </h1>

                            <h2
                                style={{
                                    marginTop: 10,
                                    marginBottom: 8,
                                    color: "#444",
                                    fontWeight: 600
                                }}
                            >
                                PROCESS LABORATORY REPORT
                            </h2>

                            <div
                                style={{
                                    fontSize: 17,
                                    fontWeight: "bold",
                                    color: "#666"
                                }}
                            >
                                ATMOSPHERIC DISTILLATION UNIT (ADU)
                            </div>

                            <div
                                style={{
                                    marginTop: 10,
                                    fontSize: 13,
                                    color: "#888"
                                }}
                            >
                                Equipment Tag : T-102
                            </div>

                        </div>


                        <div className="receipt-section">

                            <table className="receipt-table">

                                <tbody>

                                    <tr>

                                        <td>
                                            Report Number
                                        </td>

                                        <td>
                                            {report.reportNumber}
                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Date Generated
                                        </td>

                                        <td>
                                            {report.generated}
                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Process Unit
                                        </td>

                                        <td>
                                            Atmospheric Distillation Unit
                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Equipment
                                        </td>

                                        <td>
                                            Main Fractionation Tower
                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Feed Source
                                        </td>

                                        <td>
                                            PreFlash Tower Bottoms
                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Feed Flow
                                        </td>

                                        <td>

                                            {Number(feed.flow || 0).toFixed(3)}

                                            m³/hr

                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Feed Temperature
                                        </td>

                                        <td>

                                            {Number(feed.temperature || 0).toFixed(2)}

                                            °C

                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Feed Pressure
                                        </td>

                                        <td>

                                            {Number(feed.pressure || 0).toFixed(3)}

                                            barg

                                        </td>

                                    </tr>


                                    <tr>

                                        <td>
                                            Generated By
                                        </td>

                                        <td>
                                            NK Refinery Digital Twin System
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        <div
                            className="receipt-section"
                            style={{
                                textAlign: "center",
                                marginTop: "35px"
                            }}
                        >

                            <h2>

                                {

                                    performance.flashSeverity >= 0.85 ?

                                        "🟢 NORMAL OPERATION"

                                        :

                                        performance.flashSeverity >= 0.65 ?

                                            "🟡 MODERATE OPERATION"

                                            :

                                            performance.flashSeverity >= 0.40 ?

                                                "🟠 LOW FLASH SEVERITY"

                                                :

                                                "🔴 UNIT REQUIRES ATTENTION"

                                }

                            </h2>

                        </div>



                        <div
                            className="receipt-section"
                            style={{
                                marginTop: "30px"
                            }}
                        >

                            <strong>

                                REPORT DESCRIPTION

                            </strong>

                            <br /><br />

                            This report presents the operating conditions,
                            flash zone behaviour,
                            product distribution,
                            side draw performance,
                            tower thermal profile,
                            material balance,
                            separation efficiency,
                            process performance and operational status
                            of the Main Fractionation Tower.

                            <br /><br />

                            The report is generated automatically by the
                            NK Refinery Digital Twin System for training,
                            operational monitoring,
                            process evaluation,
                            troubleshooting
                            and engineering analysis.

                        </div>



                        <div
                            className="receipt-footer"
                            style={{
                                marginTop: "50px",
                                textAlign: "center"
                            }}
                        >

                            <strong>

                                CONFIDENTIAL

                            </strong>

                            <br />

                            Generated Automatically

                            <br />

                            NK Refinery Digital Twin System

                            <br />

                            Version 3.0

                        </div>

                    </div>

                )}

                {/* =========================================================
    PAGE 1
    OPERATING CONDITIONS
========================================================= */}

                {currentPage === 1 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            MAIN FRACTIONATION TOWER OPERATING CONDITIONS
                        </h2>



                        {/* ==========================================
            FEED CONDITIONS
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Feed Conditions</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Parameter</th>

                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Feed Flow</td>

                                        <td>

                                            {Number(feed.flow || 0).toFixed(3)}

                                            m³/hr

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Feed Temperature</td>

                                        <td>

                                            {Number(feed.temperature || 0).toFixed(2)}

                                            °C

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Feed Pressure</td>

                                        <td>

                                            {Number(feed.pressure || 0).toFixed(3)}

                                            barg

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
            OPERATIONAL PARAMETERS
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Operating Parameters</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Parameter</th>

                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Flash Severity</td>

                                        <td>

                                            {Number(operation.flashSeverity || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Reflux Ratio</td>

                                        <td>

                                            {Number(operation.refluxRatio || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Steam Ratio</td>

                                        <td>

                                            {Number(operation.steamRatio || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Reflux Cooling</td>

                                        <td>

                                            {Number(operation.refluxCooling || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Steam Cooling</td>

                                        <td>

                                            {Number(operation.steamCooling || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
            FLASH ZONE
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Flash Zone</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Parameter</th>

                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Flash Zone Vapor Flow</td>

                                        <td>

                                            {Number(flashZone.vaporFlow || 0).toFixed(3)}

                                            m³/hr

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Flash Zone Liquid Flow</td>

                                        <td>

                                            {Number(flashZone.liquidFlow || 0).toFixed(3)}

                                            m³/hr

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Flash Zone Pressure</td>

                                        <td>

                                            {Number(flashZone.pressure || 0).toFixed(3)}

                                            barg

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
            TOWER PROFILE
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Tower Operating Profile</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Location</th>

                                        <th>Temperature (°C)</th>

                                        <th>Pressure (barg)</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Top Section</td>

                                        <td>

                                            {Number(top.temperature || 0).toFixed(2)}

                                        </td>

                                        <td>

                                            {Number(top.pressure || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Upper Section</td>

                                        <td>

                                            {Number(upperSection.temperature || 0).toFixed(2)}

                                        </td>

                                        <td>

                                            {Number(upperSection.pressure || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Middle Section</td>

                                        <td>

                                            {Number(middle.temperature || 0).toFixed(2)}

                                        </td>

                                        <td>

                                            {Number(middle.pressure || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Flash Zone</td>

                                        <td>

                                            {Number(flash.temperature || 0).toFixed(2)}

                                        </td>

                                        <td>

                                            {Number(flash.pressure || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Bottom Section</td>

                                        <td>

                                            {Number(bottom.temperature || 0).toFixed(2)}

                                        </td>

                                        <td>

                                            {Number(bottom.pressure || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                )}

                {/* =========================================================
    PAGE 2
    PRODUCT DISTRIBUTION & MATERIAL BALANCE
========================================================= */}

                {currentPage === 2 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            PRODUCT DISTRIBUTION & MATERIAL BALANCE
                        </h2>


                        {/* ==========================================
            PRODUCT FLOWS
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Product Flow Summary</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Product</th>
                                        <th>Flow (m³/hr)</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Overhead Product</td>

                                        <td>
                                            {Number(overhead.flow || 0).toFixed(3)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Kerosene Side Draw</td>

                                        <td>
                                            {Number(kerosene.flow || 0).toFixed(3)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Diesel Side Draw</td>

                                        <td>
                                            {Number(diesel.flow || 0).toFixed(3)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Bottom Product</td>

                                        <td>
                                            {Number(bottoms.flow || 0).toFixed(3)}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
            MATERIAL BALANCE
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Overall Material Balance</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Description</th>
                                        <th>Flow (m³/hr)</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Total Feed</td>

                                        <td>

                                            {Number(feed.flow || 0).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Total Products</td>

                                        <td>

                                            {(
                                                Number(overhead.flow || 0)
                                                +
                                                Number(kerosene.flow || 0)
                                                +
                                                Number(diesel.flow || 0)
                                                +
                                                Number(bottoms.flow || 0)
                                            ).toFixed(3)}

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Material Balance Error</td>

                                        <td>

                                            {(
                                                Number(feed.flow || 0)
                                                -
                                                (
                                                    Number(overhead.flow || 0)
                                                    +
                                                    Number(kerosene.flow || 0)
                                                    +
                                                    Number(diesel.flow || 0)
                                                    +
                                                    Number(bottoms.flow || 0)
                                                )
                                            ).toFixed(3)}

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
            PRODUCT YIELDS
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Product Yield Distribution</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Product</th>

                                        <th>% of Feed</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Overhead</td>

                                        <td>

                                            {(
                                                Number(overhead.flow || 0)
                                                /
                                                Math.max(Number(feed.flow || 1), 1)
                                                *
                                                100
                                            ).toFixed(2)}

                                            %

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Kerosene</td>

                                        <td>

                                            {(
                                                Number(kerosene.flow || 0)
                                                /
                                                Math.max(Number(feed.flow || 1), 1)
                                                *
                                                100
                                            ).toFixed(2)}

                                            %

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Diesel</td>

                                        <td>

                                            {(
                                                Number(diesel.flow || 0)
                                                /
                                                Math.max(Number(feed.flow || 1), 1)
                                                *
                                                100
                                            ).toFixed(2)}

                                            %

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Bottoms</td>

                                        <td>

                                            {(
                                                Number(bottoms.flow || 0)
                                                /
                                                Math.max(Number(feed.flow || 1), 1)
                                                *
                                                100
                                            ).toFixed(2)}

                                            %

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
            UNIT STATUS
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Overall Unit Status</h3>

                            <table className="receipt-table">

                                <tbody>

                                    <tr>

                                        <td>Feed Rate</td>

                                        <td>

                                            {Number(feed.flow || 0).toFixed(3)}

                                            m³/hr

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Total Product Rate</td>

                                        <td>

                                            {(
                                                Number(overhead.flow || 0)
                                                +
                                                Number(kerosene.flow || 0)
                                                +
                                                Number(diesel.flow || 0)
                                                +
                                                Number(bottoms.flow || 0)
                                            ).toFixed(3)}

                                            m³/hr

                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Recovery Efficiency</td>

                                        <td>

                                            {(
                                                (
                                                    Number(overhead.flow || 0)
                                                    +
                                                    Number(kerosene.flow || 0)
                                                    +
                                                    Number(diesel.flow || 0)
                                                    +
                                                    Number(bottoms.flow || 0)
                                                )
                                                /
                                                Math.max(Number(feed.flow || 1), 1)
                                                *
                                                100
                                            ).toFixed(2)}

                                            %

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                )}



                {/* =========================================================
    PAGE 3
    COMPONENT FRACTIONATION ANALYSIS
========================================================= */}

                {currentPage === 3 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            COMPONENT FRACTIONATION ANALYSIS
                        </h2>


                        {/* ==========================================
        OVERHEAD COMPOSITION
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Overhead Product Composition</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Component</th>
                                        <th>Quantity</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Light Naphtha</td>

                                        <td>
                                            {(overhead.composition?.LightNaphtha || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Heavy Naphtha</td>

                                        <td>
                                            {(overhead.composition?.HeavyNaphtha || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Kerosene</td>

                                        <td>
                                            {(overhead.composition?.Kerosene || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Diesel</td>

                                        <td>
                                            {(overhead.composition?.Diesel || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>VGO</td>

                                        <td>
                                            {(overhead.composition?.VGO || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Residue</td>

                                        <td>
                                            {(overhead.composition?.Residue || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        KEROSENE PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Kerosene Side Draw Composition</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Component</th>
                                        <th>Quantity</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Kerosene</td>

                                        <td>
                                            {(kerosene.composition?.Kerosene || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Diesel</td>

                                        <td>
                                            {(kerosene.composition?.Diesel || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        DIESEL PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Diesel Side Draw Composition</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Component</th>
                                        <th>Quantity</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Diesel</td>

                                        <td>
                                            {(diesel.composition?.Diesel || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>VGO</td>

                                        <td>
                                            {(diesel.composition?.VGO || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        BOTTOM PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Bottom Product Composition</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Component</th>
                                        <th>Quantity</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>

                                        <td>Light Naphtha</td>

                                        <td>
                                            {(bottoms.composition?.LightNaphtha || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Heavy Naphtha</td>

                                        <td>
                                            {(bottoms.composition?.HeavyNaphtha || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Kerosene</td>

                                        <td>
                                            {(bottoms.composition?.Kerosene || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Diesel</td>

                                        <td>
                                            {(bottoms.composition?.Diesel || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>VGO</td>

                                        <td>
                                            {(bottoms.composition?.VGO || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Residue</td>

                                        <td>
                                            {(bottoms.composition?.Residue || 0).toFixed(2)}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                )}


                {/* =========================================================
    PAGE 4
    TOWER PERFORMANCE ANALYSIS
========================================================= */}

                {currentPage === 4 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            TOWER PERFORMANCE ANALYSIS
                        </h2>


                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Performance Parameter</th>
                                    <th>Value</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Total Feed</td>

                                    <td>
                                        {(feed.flow || 0).toFixed(2)} m³/hr
                                    </td>

                                </tr>

                                <tr>

                                    <td>Flash Zone Vapor Flow</td>

                                    <td>
                                        {(flashZone.vaporFlow || 0).toFixed(2)} m³/hr
                                    </td>

                                </tr>

                                <tr>

                                    <td>Flash Zone Liquid Flow</td>

                                    <td>
                                        {(flashZone.liquidFlow || 0).toFixed(2)} m³/hr
                                    </td>

                                </tr>

                                <tr>

                                    <td>Flash Severity</td>

                                    <td>
                                        {(flashZone.flashSeverity || 0).toFixed(3)}
                                    </td>

                                </tr>

                                <tr>

                                    <td>Reflux Ratio</td>

                                    <td>
                                        {(operation.refluxRatio || 0).toFixed(3)}
                                    </td>

                                </tr>

                                <tr>

                                    <td>Steam Ratio</td>

                                    <td>
                                        {(operation.steamRatio || 0).toFixed(3)}
                                    </td>

                                </tr>

                                <tr>

                                    <td>Kerosene Recovery</td>

                                    <td>
                                        {(performance.keroseneRecovery || 0).toFixed(2)} %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Diesel Recovery</td>

                                    <td>
                                        {(performance.dieselRecovery || 0).toFixed(2)} %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Overhead Recovery</td>

                                    <td>
                                        {(performance.overheadRecovery || 0).toFixed(2)} %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Bottoms Recovery</td>

                                    <td>
                                        {(performance.bottomsRecovery || 0).toFixed(2)} %
                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Separation Efficiency</td>

                                    <td>

                                        <strong>

                                            {(performance.separationEfficiency || 0).toFixed(2)} %

                                        </strong>

                                    </td>

                                </tr>

                                <tr>

                                    <td>Overall Tower Performance</td>

                                    <td>

                                        <strong>

                                            {performance.performanceRating || "N/A"}

                                        </strong>

                                    </td>

                                </tr>

                            </tbody>

                        </table>



                        <br />



                        <div className="receipt-section">

                            <h3>Operational Assessment</h3>

                            <table className="receipt-table">

                                <tbody>

                                    <tr>

                                        <td>Flash Zone Stability</td>

                                        <td>
                                            {performance.flashZoneStatus || "Stable"}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Heat Balance</td>

                                        <td>
                                            {performance.heatBalance || "Balanced"}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Column Hydraulic Loading</td>

                                        <td>
                                            {performance.columnLoading || "Normal"}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Flooding Tendency</td>

                                        <td>
                                            {performance.floodingRisk || "Low"}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Weeping Tendency</td>

                                        <td>
                                            {performance.weepingRisk || "Low"}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Recommended Action</td>

                                        <td>
                                            {performance.recommendation || "Continue Normal Operation"}
                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                )}


                {/* =========================================================
    PAGE 5
    PRODUCT QUALITY ANALYSIS
========================================================= */}

                {currentPage === 5 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            PRODUCT QUALITY ANALYSIS REPORT
                        </h2>


                        {/* ==========================================
        OVERHEAD PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Overhead Product</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Property</th>
                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Flow Rate</td>
                                        <td>{(overhead.flow || 0).toFixed(2)} m³/hr</td>
                                    </tr>

                                    <tr>
                                        <td>Temperature</td>
                                        <td>{(top.temperature || 0).toFixed(1)} °C</td>
                                    </tr>

                                    <tr>
                                        <td>Pressure</td>
                                        <td>{(top.pressure || 0).toFixed(3)} barg</td>
                                    </tr>

                                    <tr>
                                        <td>Light Naphtha</td>
                                        <td>{(overhead.composition?.LightNaphtha || 0).toFixed(2)} %</td>
                                    </tr>

                                    <tr>
                                        <td>Heavy Naphtha</td>
                                        <td>{(overhead.composition?.HeavyNaphtha || 0).toFixed(2)} %</td>
                                    </tr>

                                    <tr>
                                        <td>Kerosene</td>
                                        <td>{(overhead.composition?.Kerosene || 0).toFixed(2)} %</td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        KEROSENE PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Kerosene Product</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Property</th>
                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Flow Rate</td>
                                        <td>{(kerosene.flow || 0).toFixed(2)} m³/hr</td>
                                    </tr>

                                    <tr>
                                        <td>Draw Temperature</td>
                                        <td>{(middle.temperature || 0).toFixed(1)} °C</td>
                                    </tr>

                                    <tr>
                                        <td>Kerosene</td>
                                        <td>{(kerosene.composition?.Kerosene || 0).toFixed(2)} %</td>
                                    </tr>

                                    <tr>
                                        <td>Diesel Contamination</td>
                                        <td>{(kerosene.composition?.Diesel || 0).toFixed(2)} %</td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        DIESEL PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Diesel Product</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Property</th>
                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Flow Rate</td>
                                        <td>{(diesel.flow || 0).toFixed(2)} m³/hr</td>
                                    </tr>

                                    <tr>
                                        <td>Draw Temperature</td>
                                        <td>{(flash.temperature || 0).toFixed(1)} °C</td>
                                    </tr>

                                    <tr>
                                        <td>Diesel</td>
                                        <td>{(diesel.composition?.Diesel || 0).toFixed(2)} %</td>
                                    </tr>

                                    <tr>
                                        <td>VGO Contamination</td>
                                        <td>{(diesel.composition?.VGO || 0).toFixed(2)} %</td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        BOTTOM PRODUCT
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Atmospheric Residue</h3>

                            <table className="receipt-table">

                                <thead>

                                    <tr>

                                        <th>Property</th>
                                        <th>Value</th>

                                    </tr>

                                </thead>

                                <tbody>

                                    <tr>
                                        <td>Flow Rate</td>
                                        <td>{(bottoms.flow || 0).toFixed(2)} m³/hr</td>
                                    </tr>

                                    <tr>
                                        <td>Temperature</td>
                                        <td>{(bottom.temperature || 0).toFixed(1)} °C</td>
                                    </tr>

                                    <tr>
                                        <td>Pressure</td>
                                        <td>{(bottom.pressure || 0).toFixed(3)} barg</td>
                                    </tr>

                                    <tr>
                                        <td>Diesel</td>
                                        <td>{(bottoms.composition?.Diesel || 0).toFixed(2)} %</td>
                                    </tr>

                                    <tr>
                                        <td>VGO</td>
                                        <td>{(bottoms.composition?.VGO || 0).toFixed(2)} %</td>
                                    </tr>

                                    <tr>
                                        <td>Residue</td>
                                        <td>{(bottoms.composition?.Residue || 0).toFixed(2)} %</td>
                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        LABORATORY REMARK
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Laboratory Remarks</h3>

                            <p>

                                Product qualities shown above were generated from the
                                NK Refinery Digital Twin atmospheric fractionation
                                process model. Product distributions are based on
                                current operating conditions, flash zone performance,
                                reflux ratio, stripping steam rate and simulated tray
                                separation efficiency.

                            </p>

                        </div>

                    </div>

                )}

                {/* =========================================================
    PAGE 6
    LABORATORY CERTIFICATION
========================================================= */}

                {currentPage === 6 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            LABORATORY CERTIFICATION
                        </h2>



                        {/* ==========================================
        REPORT INFORMATION
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Report Information</h3>

                            <table className="receipt-table">

                                <tbody>

                                    <tr>

                                        <td>Report Number</td>

                                        <td>
                                            {report.reportNumber || "N/A"}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Generated On</td>

                                        <td>
                                            {report.generated || new Date().toLocaleString()}
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Sample Source</td>

                                        <td>
                                            Main Fractionation Tower
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Report Type</td>

                                        <td>
                                            Process Performance & Laboratory Analysis
                                        </td>

                                    </tr>

                                    <tr>

                                        <td>Simulation Status</td>

                                        <td>

                                            <span
                                                style={{
                                                    color: "green",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                VERIFIED
                                            </span>

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>



                        {/* ==========================================
        OPERATOR REMARK
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Operator Remarks</h3>

                            <p>

                                The Main Fractionation Tower operated within the
                                expected process envelope during this reporting
                                period. Product separation, reflux control,
                                flash zone stability, side draw performance
                                and bottoms recovery were evaluated using
                                the NK Refinery Digital Twin simulation model.

                            </p>

                        </div>



                        {/* ==========================================
        LABORATORY CERTIFICATION
    ========================================== */}

                        <div className="receipt-section">

                            <h3>Laboratory Certification</h3>

                            <p>

                                This report has been automatically generated
                                by the NK Refinery Digital Twin System using
                                real-time process calculations, equipment
                                operating conditions and simulated laboratory
                                product analysis.

                            </p>

                            <p>

                                The values contained herein are intended solely
                                for operator training, refinery simulation,
                                process monitoring, digital twin validation
                                and educational purposes.

                            </p>

                        </div>



                        {/* ==========================================
        SIGNATURES
    ========================================== */}

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Position</th>

                                    <th>Name</th>

                                    <th>Signature</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>Process Operator</td>

                                    <td>____________________</td>

                                    <td>____________________</td>

                                </tr>

                                <tr>

                                    <td>Shift Supervisor</td>

                                    <td>____________________</td>

                                    <td>____________________</td>

                                </tr>

                                <tr>

                                    <td>Laboratory Engineer</td>

                                    <td>____________________</td>

                                    <td>____________________</td>

                                </tr>

                                <tr>

                                    <td>Production Superintendent</td>

                                    <td>____________________</td>

                                    <td>____________________</td>

                                </tr>

                            </tbody>

                        </table>



                        <br />



                        {/* ==========================================
        QR CODE
    ========================================== */}

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginTop: "20px"
                            }}
                        >

                            <div>

                                <QRCode

                                    value={JSON.stringify({

                                        report:

                                            report.reportNumber ||

                                            "UNKNOWN",

                                        generated:

                                            report.generated ||

                                            new Date().toLocaleString(),

                                        unit:

                                            "Main Fractionation Tower"

                                    })}

                                    size={110}

                                />

                            </div>


                            <div>

                                <Barcode

                                    value={
                                        report.reportNumber ||

                                        "MAIN-FRACTIONATION"
                                    }

                                    height={45}

                                    width={1.4}

                                    fontSize={12}

                                />

                            </div>

                        </div>



                        <br />



                        {/* ==========================================
        DISCLAIMER
    ========================================== */}

                        <div
                            className="lab-disclaimer"
                            style={{
                                marginTop: "20px"
                            }}
                        >

                            <strong>DISCLAIMER</strong>

                            <br /><br />

                            This laboratory report is generated by the NK
                            Refinery Digital Twin System and is intended for
                            training, process simulation, engineering studies,
                            refinery performance evaluation and educational
                            demonstrations only.

                            Laboratory values represent mathematically
                            simulated process results and should not be
                            interpreted as certified commercial laboratory
                            analyses.

                        </div>

                    </div>

                )}



                {/* =========================================================
    PAGE 7
    ADVANCED PROCESS DIAGNOSTICS
========================================================= */}

                {currentPage === 7 && (

                    <div className="receipt-page">

                        <h2
                            style={{
                                textAlign: "center",
                                marginBottom: "25px"
                            }}
                        >
                            ADVANCED PROCESS DIAGNOSTICS
                        </h2>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>Process Variable</th>
                                    <th>Current</th>
                                    <th>Status</th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>
                                    <td>Feed Temperature</td>
                                    <td>{(feed.temperature || 0).toFixed(1)} °C</td>
                                    <td>{feed.temperature > 320 ? "Normal" : "Low"}</td>
                                </tr>

                                <tr>
                                    <td>Feed Pressure</td>
                                    <td>{(feed.pressure || 0).toFixed(3)} barg</td>
                                    <td>{feed.pressure < 3 ? "Normal" : "High"}</td>
                                </tr>

                                <tr>
                                    <td>Flash Severity</td>
                                    <td>{(flashZone.flashSeverity || 0).toFixed(3)}</td>
                                    <td>
                                        {(flashZone.flashSeverity || 0) > 0.70
                                            ? "Excellent"
                                            : "Moderate"}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Overhead Recovery</td>
                                    <td>{(performance.overheadRecovery || 0).toFixed(2)} %</td>
                                    <td>
                                        {(performance.overheadRecovery || 0) > 85
                                            ? "Excellent"
                                            : "Review"}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Kerosene Recovery</td>
                                    <td>{(performance.keroseneRecovery || 0).toFixed(2)} %</td>
                                    <td>
                                        {(performance.keroseneRecovery || 0) > 90
                                            ? "Excellent"
                                            : "Monitor"}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Diesel Recovery</td>
                                    <td>{(performance.dieselRecovery || 0).toFixed(2)} %</td>
                                    <td>
                                        {(performance.dieselRecovery || 0) > 90
                                            ? "Excellent"
                                            : "Monitor"}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Tower Efficiency</td>
                                    <td>{(performance.separationEfficiency || 0).toFixed(2)} %</td>
                                    <td>
                                        {(performance.separationEfficiency || 0) > 90
                                            ? "Excellent"
                                            : "Fair"}
                                    </td>
                                </tr>

                                <tr>
                                    <td>Overall Plant Condition</td>
                                    <td colSpan="2">

                                        <strong>

                                            {performance.performanceRating || "NORMAL"}

                                        </strong>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                        <br />

                        <div className="receipt-section">

                            <h3>Engineering Recommendations</h3>

                            <ul>

                                <li>
                                    Maintain furnace outlet temperature within design limits.
                                </li>

                                <li>
                                    Maintain flash zone pressure for optimum vapor-liquid equilibrium.
                                </li>

                                <li>
                                    Optimize reflux ratio to maximize naphtha recovery.
                                </li>

                                <li>
                                    Monitor stripping steam to improve kerosene and diesel separation.
                                </li>

                                <li>
                                    Monitor tray temperatures for early indication of flooding or weeping.
                                </li>

                                <li>
                                    Continue monitoring product side draw quality.
                                </li>

                            </ul>

                        </div>

                    </div>

                )}

                {/* =========================================================
   PAGE 8
   PERFORMANCE SUMMARY
========================================================= */}

                {currentPage === 8 && (

                    <div className="receipt-page">

                        <h2>
                            MAIN FRACTIONATION TOWER
                        </h2>

                        <h3>
                            Performance Summary
                        </h3>

                        <table className="receipt-table">

                            <thead>

                                <tr>

                                    <th>
                                        Performance Parameter
                                    </th>

                                    <th>
                                        Value
                                    </th>

                                    <th>
                                        Status
                                    </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr>

                                    <td>
                                        Feed Rate
                                    </td>

                                    <td>
                                        {(feed.flow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>
                                        Stable
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Flash Severity
                                    </td>

                                    <td>
                                        {(operation.flashSeverity || 0).toFixed(3)}
                                    </td>

                                    <td>

                                        {(operation.flashSeverity || 0) >= 0.80 ?

                                            "High"

                                            :

                                            (operation.flashSeverity || 0) >= 0.55 ?

                                                "Normal"

                                                :

                                                "Low"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Flash Zone Vapor
                                    </td>

                                    <td>
                                        {(flashZone.vaporFlow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>
                                        Active
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Flash Zone Liquid
                                    </td>

                                    <td>
                                        {(flashZone.liquidFlow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>
                                        Stable
                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Overhead Product
                                    </td>

                                    <td>
                                        {(overhead.flow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>

                                        {(overhead.flow || 0) > 0 ?

                                            "Producing"

                                            :

                                            "Stopped"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Kerosene Product
                                    </td>

                                    <td>
                                        {(kerosene.flow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>

                                        {(kerosene.flow || 0) > 0 ?

                                            "Producing"

                                            :

                                            "Stopped"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Diesel Product
                                    </td>

                                    <td>
                                        {(diesel.flow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>

                                        {(diesel.flow || 0) > 0 ?

                                            "Producing"

                                            :

                                            "Stopped"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Bottoms Product
                                    </td>

                                    <td>
                                        {(bottoms.flow || 0).toFixed(2)} m³/hr
                                    </td>

                                    <td>

                                        {(bottoms.flow || 0) > 0 ?

                                            "Producing"

                                            :

                                            "Stopped"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Tower Thermal Efficiency
                                    </td>

                                    <td>
                                        {(performance.thermalEfficiency || 0).toFixed(2)} %
                                    </td>

                                    <td>

                                        {(performance.thermalEfficiency || 0) >= 85 ?

                                            "Excellent"

                                            :

                                            (performance.thermalEfficiency || 0) >= 70 ?

                                                "Good"

                                                :

                                                "Attention"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Separation Efficiency
                                    </td>

                                    <td>
                                        {(performance.separationEfficiency || 0).toFixed(2)} %
                                    </td>

                                    <td>

                                        {(performance.separationEfficiency || 0) >= 90 ?

                                            "Excellent"

                                            :

                                            (performance.separationEfficiency || 0) >= 75 ?

                                                "Good"

                                                :

                                                "Poor"}

                                    </td>

                                </tr>

                                <tr>

                                    <td>
                                        Overall Tower Status
                                    </td>

                                    <td>

                                        {(performance.overallHealth || 0).toFixed(2)} %

                                    </td>

                                    <td>

                                        {(performance.overallHealth || 0) >= 90 ?

                                            "Excellent"

                                            :

                                            (performance.overallHealth || 0) >= 75 ?

                                                "Normal"

                                                :

                                                "Needs Attention"}

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                )}

                

                <hr />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 25
                    }}
                >

                    <button
                        className="receipt-button"
                        disabled={currentPage === 0}
                        onClick={() => setCurrentPage(p => p - 1)}
                    >
                        ◀ Previous
                    </button>

                    <strong>
                        Page {currentPage + 1} of 9
                    </strong>

                    <button
                        className="receipt-button"
                        disabled={currentPage === 8}
                        onClick={() => setCurrentPage(p => p + 1)}
                    >
                        Next ▶
                    </button>

                </div>

                <br />

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: 20
                    }}
                >

                    <button
                        className="receipt-button"
                        onClick={() => window.print()}
                    >
                        Print
                    </button>

                    <button
                        className="receipt-button"
                    >
                        Export PDF
                    </button>

                    <button
                        className="receipt-button"
                        onClick={onClose}
                    >
                        Close
                    </button>

                </div>

            </div>

        </div>


    )

};

export default MainFractionationLaboratory;